module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'is-active': _vm.isActive
    }
  }, [(!_vm.hasChildren) ? _c('span', [(!_vm.click) ? _c('router-link', {
    attrs: {
      "to": _vm.to,
      "exact": ""
    }
  }, [(_vm.icon) ? _c('i', {
    staticClass: "fa",
    class: [("fa-" + _vm.icon)]
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.click) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.click
    }
  }, [(_vm.icon) ? _c('i', {
    staticClass: "fa",
    class: [("fa-" + _vm.icon)]
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.hasChildren) ? _c('span', [_c('a', {
    staticClass: "has-children",
    class: {
      'is-active': _vm.isActive, 'is-open': _vm.isOpen,
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.toggle
    }
  }, [(_vm.icon) ? _c('i', {
    staticClass: "fa",
    class: [("fa-" + _vm.icon)]
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('span', {
    staticClass: "nav-right"
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.arrowClass]
  })])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }]
  }, [_vm._t("sub")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-050c1924!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/MenuItem.vue
// module id = 327
// module chunks = 0